/** 经营总览：格式化与通用常量 */

export const MONTH_LABELS = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'];

export const MONTH_AXIS = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];

export const QUARTER_AXIS = ['Q1', 'Q2', 'Q3', 'Q4'];
/** 稿面利润率目标线 */
export const PROFIT_RATE_TARGET = 0.55;

export const emptyMonthSeries = () => Array.from({ length: 12 }, () => 0);

export const formatContractTotal = (value) => {
	const num = Number(value) || 0;
	const abs = Math.abs(num);
	/** ≥100 万用 M，避免 W 位数过长 */
	if (abs >= 1e6) return `¥${(num / 1e6).toFixed(abs >= 1e7 ? 0 : 1)}M`;
	if (abs >= 10000) return `¥${(num / 10000).toFixed(2)}W`;
	return `¥${num.toLocaleString('zh-CN', { maximumFractionDigits: 0 })}`;
};

/** KPI 环图/气泡标签：短金额用 W/k；过长（≥100万）改用 M */
export const formatDonutCenter = (value) => {
	const num = Number(value) || 0;
	const abs = Math.abs(num);
	if (abs >= 1e6) return `¥${(num / 1e6).toFixed(abs >= 1e7 ? 0 : 1)}M`;
	if (abs >= 10000) return `¥${(num / 10000).toFixed(1)}W`;
	if (abs >= 1000) return `¥${(num / 1000).toFixed(1)}k`;
	return `¥${Math.round(num).toLocaleString('zh-CN')}`;
};

export const sumSliceTotalPrice = (slices = []) => slices.reduce((sum, item) => sum + (Number(item.totalPrice) || 0), 0);

export const sum = (values) => values.reduce((acc, n) => acc + n, 0);

export const formatWanTotal = (values) => `¥${sum(values).toFixed(2)}万`;

export const formatOrderCountTotal = (values) => `${sum(values)}单`;

/** 分段顶栏：¥47.8k · 35单 */
export const formatOverviewStageMetric = (totalPrice, count) => `${formatDonutCenter(totalPrice)} · ${Number(count) || 0}单`;

